import { MapsAPILoader } from '@agm/core';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';

interface AutocompletePlace {
  placeId: string;
  country: string;
  state: string;
  city: string;
  neighborhood: string;
  address: string;
  zipCode: string;
}

@Directive({
  selector: '[appGoogleAutocomplete]',
})
export class GoogleAutocompleteDirective implements AfterViewInit {
  @Input() id = 'location';
  @Output() residenceAutocompleted: EventEmitter<AutocompletePlace> =
    new EventEmitter();
  constructor(
    private elementRef: ElementRef,
    private mapsAPILoader: MapsAPILoader
  ) {}

  ngAfterViewInit() {
    const nativeElement = _get(this.elementRef, 'nativeElement', null);
    if (nativeElement) {
      const elementInput: HTMLInputElement = nativeElement.querySelector(
        `input[id=${this.id}]`
      );
      if (elementInput) {
        this.loadGoogleMapSearchAutocomplete(elementInput);
      }
    }
  }

  loadGoogleMapSearchAutocomplete(element) {
    this.mapsAPILoader.load().then(() => {
      const autocomplete: any = new google.maps.places.Autocomplete(element);
      autocomplete.addListener('place_changed', () => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }
        const addressComponents = _get(place, 'address_components', []);
        const placeId = _get(place, 'place_id', []);
        const route = _get(place, 'name', '');
        const country = _get(
          _find(addressComponents, (placeData) =>
            _find(_get(placeData, 'types', []), (type) => type === 'country')
          ),
          'long_name',
          ''
        );
        const state = _get(
          _find(addressComponents, (placeData) =>
            _find(
              _get(placeData, 'types', []),
              (type) => type === 'administrative_area_level_1'
            )
          ),
          'long_name',
          ''
        );
        const city = _get(
          _find(addressComponents, (placeData) =>
            _find(
              _get(placeData, 'types', []),
              (type) => type === 'administrative_area_level_2'
            )
          ),
          'long_name',
          ''
        );
        const neighborhood = _get(
          _find(addressComponents, (placeData) =>
            _find(
              _get(placeData, 'types', []),
              (type) => type === 'neighborhood'
            )
          ),
          'long_name',
          ''
        );
        const address = _get(place, 'formatted_address', '');
        const zipCode = _get(
          _find(addressComponents, (placeData) =>
            _find(
              _get(placeData, 'types', []),
              (type) => type === 'postal_code'
            )
          ),
          'long_name',
          ''
        );
        const residenceData = {
          placeId,
          route,
          country,
          state,
          city,
          neighborhood,
          address,
          zipCode,
        };
        this.residenceAutocompleted.emit(residenceData);
      });
    });
  }
}
